import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
export const transformCaseGenerator = (toCase) => (params, filter) => {
    if (!params)
        return {};
    const transformToGivenCase = (path, params, filter) => {
        if (!isObject(params) || (filter && filter(params, path, true)))
            return params;
        if (isArray(params))
            return params.map((param, index) => transformToGivenCase(`${path}[${index}]`, param, filter));
        const mappedParams = mapValues(params, (param, key) => transformToGivenCase(`${path}${path ? '.' : ''}${key}`, param, filter));
        return mapKeys(mappedParams, (param, key) => filter && filter(param, `${path}${path ? '.' : ''}${key}`, false)
            ? key
            : toCase(key));
    };
    return transformToGivenCase('', params, filter);
};
export const toCamelCase = transformCaseGenerator(camelCase);
export const toSnakeCase = transformCaseGenerator(snakeCase);
//# sourceMappingURL=transform-case.js.map